import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getEducationDetailQueryOptions } from '../getEducationDetail/getEducationDetailQueryOptions';
import { GetEducationDetailQueryResponseType } from '../getEducationDetail/getEducationDetailQuery.type';
import { likeEducationFunction } from './likeEducationQueryFunction';

export const useLikeEducationQueryOptions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['likeEducation'],
    mutationFn: (data: { id: number }) => likeEducationFunction(data),

    onMutate: async ({ id }) => {
      const queryKey = getEducationDetailQueryOptions({
        id: String(id),
      }).queryKey;

      await queryClient.cancelQueries({ queryKey });

      const previousData =
        queryClient.getQueryData<GetEducationDetailQueryResponseType>(queryKey);

      queryClient.setQueryData<GetEducationDetailQueryResponseType>(
        queryKey,
        (old) => {
          if (!old) return old;

          const nextLiked = !old.liked;

          return {
            ...old,
            liked: nextLiked,
            likes_count: nextLiked
              ? (old.likes_count ?? 0) + 1
              : Math.max((old.likes_count ?? 0) - 1, 0),
          };
        },
      );

      return { previousData, queryKey };
    },

    onError: (_error, _variables, context) => {
      if (context?.previousData && context?.queryKey) {
        queryClient.setQueryData(context.queryKey, context.previousData);
      }
    },
  });
};
